export const SET_CREATE_OR_EDIT_TEAM = 'SET_CREATE_OR_EDIT_TEAM';

export function setCreateOrEditTeam(team) {
  return {
    type: SET_CREATE_OR_EDIT_TEAM,
    team,
  };
}
